// Stable IDs for every hideable KPI card/section.
// Used by KpiCardVisibilityWidget (admin toggles), KPIDashboardWidget and
// MainForm (conditional rendering). Missing keys in the saved config mean
// "visible". IDs prefixed `dash_` control the main dashboard cards in
// MainForm; the rest control the KPI Dashboard module.
export const KPI_CARD_GROUPS = [
  {
    title: 'Hovedside — ordre-kort',
    cards: [
      { id: 'dash_production', label: 'Ordrer i produksjon' },
      { id: 'dash_planned', label: 'Planlagte ordre' },
      { id: 'dash_completed', label: 'Ferdige ordre i dag' },
      { id: 'dash_stopped', label: 'Stopper / Avvik' },
      { id: 'dash_oee', label: 'OEE · Maskinutnyttelse' },
    ],
  },
  {
    title: 'Hovedside — kompakte kort',
    cards: [
      { id: 'dash_deadlines', label: 'Frister i dag' },
      { id: 'dash_notifications', label: 'Nye varsler' },
      { id: 'dash_pendingFollowup', label: 'Venter oppfølging (alle kort)' },
      { id: 'dash_rotation', label: 'Teamleder-rotasjon (alle kort)' },
    ],
  },
  {
    title: 'Hovedside — seksjoner',
    cards: [
      { id: 'dash_steelPrices', label: 'Stålpriser' },
      { id: 'dash_sales', label: 'Salg' },
      { id: 'dash_machines', label: 'Maskintimer' },
      { id: 'dash_productionToday', label: 'Produksjon i dag' },
      { id: 'dash_capacity', label: 'Kapasitet' },
    ],
  },
  {
    title: 'KPI Dashboard — ordre-kort',
    cards: [
      { id: 'totalOrders', label: 'Totalt ordre' },
      { id: 'completedOrders', label: 'Fullførte' },
      { id: 'activeOrders', label: 'Pågående' },
      { id: 'delayedOrders', label: 'Forsinket' },
    ],
  },
  {
    title: 'KPI Dashboard — økonomi-kort',
    cards: [
      { id: 'invoicedTotal', label: 'Fakturert totalt' },
      { id: 'pendingTotal', label: 'Venter på oppfølging / fakturering' },
    ],
  },
  {
    title: 'KPI Dashboard — analyse-seksjoner',
    cards: [
      { id: 'reactionTime', label: 'Reaksjonstid' },
      { id: 'teamPerformance', label: 'Team Ytelse' },
    ],
  },
];

export const isKpiCardVisible = (visibility, id) => visibility?.[id] !== false;

// Maps a MainForm secondary-stats `type` to its visibility key. Dynamic types
// (pendingFollowup_<userId>, rotation_<teamId>) collapse to a group toggle.
export const secondaryStatVisibilityKey = (type) => {
  if (type.startsWith('pendingFollowup')) return 'dash_pendingFollowup';
  if (type.startsWith('rotation_')) return 'dash_rotation';
  return `dash_${type}`;
};
